import React, { useState } from "react";
import {
  Checkbox,
  FormControl,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Button,
  TextField,
  TableHead,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import LoadingSpinner from "../../../Loading/component";
import Sidebar from "../../../Navigation/Sidebar/Sidebar";

export const CohortAddUserComponent = ({
  loading,
  seedData,
  selectedUsers,
  onUserSelect,
  handleUpdateUser,
  errors,
  cohortDetailsData,
}) => {
  const [searchTerm, setSearchTerm] = useState("");

  const mergedUsers = (seedData?.users || []).map((user) => ({
    ...user,
    isChecked: selectedUsers.some((u) => u.id === user.id),
  }));

  const searchResults = mergedUsers
    .filter(
      (user) =>
        user.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user.mobile.includes(searchTerm)
    )
    .sort((a, b) => b.isChecked - a.isChecked);

  return (
    <div style={styles.mainContainer}>

      {loading && (
        <div style={styles.loadingOverlay}>
          <LoadingSpinner />
        </div>
      )}

      <Sidebar />

      <div style={styles.contentContainer}>
        <div style={styles.header}>
          <ArrowBack
            style={styles.backIcon}
            onClick={() => window.history.back()}
          />
          <h2 style={styles.heading}>Add User</h2>
        </div>

        <div style={styles.formContainer}>
          <FormControl fullWidth style={styles.formControl}>
            <p style={styles.label}>
              Add User <span style={{ color: "red" }}>*</span>
            </p>

            <div style={{ width: "70%" }}>
              <TextField
                variant="standard"
                placeholder="Search user by name or mobile..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={styles.searchField}
              />
            </div>

            <TableContainer
              component={Paper}
              style={{ ...styles.tableContainer, width: "70%" }}
            >
              <Table stickyHeader style={{ width: "100%" }}>
                <TableHead>
                  <TableRow>
                    <TableCell style={styles.tableHeaderCell}>Select</TableCell>
                    <TableCell style={styles.tableHeaderCell}>ID</TableCell>
                    <TableCell style={styles.tableHeaderCell}>Name</TableCell>
                    <TableCell style={styles.tableHeaderCell}>Mobile</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {searchResults.length > 0 ? (
                    searchResults.map((user, index) => (
                      <TableRow
                        key={user.id}
                        style={index % 2 === 0 ? styles.rowEven : styles.rowOdd}
                      >
                        <TableCell style={styles.tableBodyCell}>
                          <Checkbox
                            checked={user.isChecked}
                            onChange={(e) =>
                              onUserSelect(user, e.target.checked)
                            }
                            disabled={cohortDetailsData?.users?.some(
                              (u) => u.id === user.id
                            )}
                          />
                        </TableCell>
                        <TableCell style={styles.tableBodyCell}>
                          {user.id}
                        </TableCell>
                        <TableCell style={styles.tableBodyCell}>
                          {user.name || "N/A"}
                        </TableCell>
                        <TableCell style={styles.tableBodyCell}>
                          {user.mobile}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} style={styles.noData}>
                        No users found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {errors?.selectedUsers && (
              <p style={styles.errorMessage}>{errors.selectedUsers}</p>
            )}

<Button
  variant="contained"
  style={{
    ...styles.addButton,
    backgroundColor: selectedUsers.filter(user => 
      !cohortDetailsData?.users?.some(existingUser => existingUser.id === user.id)
    ).length === 0 ? "#ccc" : "#14AE78", // Gray if disabled, Green if enabled
    cursor: selectedUsers.filter(user => 
      !cohortDetailsData?.users?.some(existingUser => existingUser.id === user.id)
    ).length === 0 ? "not-allowed" : "pointer", // Change cursor on hover
  }}
  onClick={handleUpdateUser}
  disabled={
    selectedUsers.filter(user => 
      !cohortDetailsData?.users?.some(existingUser => existingUser.id === user.id)
    ).length === 0
  }
>
  Add
</Button>



          </FormControl>
        </div>
      </div>
    </div>
  );
};

const styles = {
  mainContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    height: "100vh",
    width: "100vw",
  },
  loadingOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  contentContainer: {
    flex: 1,
    padding: "2rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    boxSizing: "border-box",
  },
  header: {
    display: "flex",
    alignItems: "center",
    alignSelf: "flex-start",
    marginBottom: "1.5rem",
    width: "100%",
  },
  backIcon: {
    cursor: "pointer",
    fontSize: "30px",
    marginRight: "10px",
  },
  heading: {
    fontSize: "24px",
    fontWeight: "bold",
  },
  label: {
    fontSize: "18px",
    fontWeight: 500,
    textAlign: "left",
    width: "70%",
    marginBottom: "10px",
  },
  formContainer: {
    backgroundColor: "#fff",
    padding: "2rem",
    borderRadius: "16px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    width: "100%",
    maxWidth: "100vw",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    boxSizing: "border-box",
    height:"85vh"
  },
  formControl: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  searchField: {
    width: "100%",
    maxWidth: "100vw",
    marginBottom: "1rem",
  },
  tableContainer: {
    width: "100%",
    maxWidth: "100vw",
    maxHeight: "400px",
    overflowY: "auto",
    marginBottom: "1.5rem",
  },
  tableHeaderCell: {
    fontWeight: "bold",
    textAlign: "center",
    padding: "10px",
    backgroundColor: "#F0F0F0",
  },
  tableBodyCell: {
    textAlign: "center",
    padding: "10px",
  },
  noData: {
    textAlign: "center",
    padding: "20px",
  },
  rowEven: {
    backgroundColor: "#fff",
  },
  rowOdd: {
    backgroundColor: "#f8f8f8",
  },
  addButton: {
    backgroundColor: "#14AE78",
    color: "#fff",
    padding: "12px 20px",
    fontSize: "16px",
    fontWeight: "bold",
    borderRadius: "8px",
    width: "100%",
    maxWidth: "600px",
  },
  errorMessage: {
    color: "red",
    textAlign: "left",
    fontSize: "14px",
    marginTop: "10px",
    width: "100%",
    maxWidth: "500px",
  },
};



export default CohortAddUserComponent;
